/* «Les mer» på kategoritekster.
   Knappen vises bare når teksten faktisk er for lang. Er den kort nok,
   skal det ikke stå en knapp der som ikke gjør noe. */
(function () {
  const start = () => {
    document.querySelectorAll('[data-gs-lesmer]').forEach((boks) => {
      const tekst = boks.querySelector('[data-gs-tekst]');
      const knapp = boks.querySelector('[data-gs-mer]');
      if (!tekst || !knapp) return;

      const overflyter = () => tekst.scrollHeight - tekst.clientHeight > 2;

      const vurder = () => {
        if (boks.classList.contains('er-apen')) return;
        knapp.hidden = !overflyter();
      };

      vurder();
      window.addEventListener('resize', vurder);

      knapp.addEventListener('click', () => {
        const apen = boks.classList.toggle('er-apen');
        knapp.querySelector('[data-gs-mer-tekst]').textContent = apen ? 'Vis mindre' : 'Les mer';
        knapp.setAttribute('aria-expanded', apen ? 'true' : 'false');
      });
      knapp.setAttribute('aria-expanded', 'false');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Filtrer og sorter på mobil (se gs-filterrad i gs-kolleksjon.css).

   Raden er markup i snippets/facets.liquid. Her kobles den til Dawns egen
   skuff og til Dawns AJAX-oppdatering av rutenettet (FacetFiltersForm),
   så sortering gir samme jevne bytte som filtrering — uten sidelasting. */
(function () {
  const start = () => {
    const rad = document.querySelector('[data-gs-filterrad]');
    if (!rad) return;

    const knapp = rad.querySelector('[data-gs-apne-filter]');
    const velger = rad.querySelector('[data-gs-sortering]');
    const antall = rad.querySelector('[data-gs-filterantall]');
    const skuffKnapp = () => document.querySelector('.mobile-facets__wrapper summary');

    // Dawns skjulte <summary> skal ikke være et stopp på tabulatorreisen.
    const sum = skuffKnapp();
    if (sum) sum.setAttribute('tabindex', '-1');

    if (knapp) {
      knapp.addEventListener('click', () => {
        const s = skuffKnapp();
        if (s) s.click();
      });

      // Lukkes skuffen, skal fokus tilbake til knappen som åpnet den.
      const skuff = document.querySelector('.mobile-facets__disclosure');
      if (skuff && 'MutationObserver' in window) {
        new MutationObserver(() => {
          if (!skuff.hasAttribute('open')) knapp.focus({ preventScroll: true });
        }).observe(skuff, { attributes: true, attributeFilter: ['open'] });
      }
    }

    // Tallet på knappen følger de aktive filtrene, også etter AJAX-bytte.
    const oppdaterAntall = () => {
      if (!antall) return;
      const n = document.querySelectorAll('.active-facets-mobile .active-facets__button').length;
      antall.textContent = String(n);
      antall.hidden = n === 0;
    };
    const aktive = document.querySelector('.active-facets-mobile');
    if (aktive && 'MutationObserver' in window) {
      new MutationObserver(oppdaterAntall).observe(aktive, { childList: true, subtree: true });
    }

    const urlSortering = () => {
      const v = new URLSearchParams(window.location.search).get('sort_by');
      return v || (velger && velger.dataset.standard) || '';
    };

    const settSortering = (verdi) => {
      const sp = new URLSearchParams(window.location.search);
      sp.set('sort_by', verdi);
      sp.delete('page');
      // Dawns egne sorteringsfelt må peke på samme verdi. Ellers bygger
      // neste filtervalg i skuffen sin URL med den gamle.
      document.querySelectorAll('#SortBy, #SortBy-mobile').forEach((f) => {
        if (f.querySelector('option[value="' + verdi + '"]')) f.value = verdi;
      });
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        FacetFiltersForm.renderPage(sp.toString());
      } else {
        window.location.search = sp.toString();
      }
    };

    if (velger) {
      // Velgeren i raden skal alltid vise det rutenettet er sortert etter.
      // Sorteringen kan endres tre steder: her, i feltet i skuffen
      // (#SortBy-mobile) og med tilbake-knappen. Dawn oppdaterer bare de to
      // første feltene, ikke denne velgeren, så raden sto på «Anbefalt» mens
      // rutenettet var sortert etter pris. Verre: da kunne kunden ikke velge
      // «Anbefalt» igjen fra raden, for verdien var allerede «Anbefalt» og
      // change-hendelsen kom aldri. Målt 13.10.26.
      const vis = (verdi) => {
        if (verdi && velger.value !== verdi && velger.querySelector('option[value="' + verdi + '"]')) {
          velger.value = verdi;
        }
      };

      velger.addEventListener('change', () => settSortering(velger.value));

      // Kunden velger i skuffen: følg valget med en gang.
      document.addEventListener('change', (hendelse) => {
        const felt = hendelse.target;
        if (felt && felt !== velger && felt.matches && felt.matches('#SortBy, #SortBy-mobile')) vis(felt.value);
      });

      // Dawn bytter ut rutenettet etter hvert filtervalg. URL-en er oppdatert
      // før det skjer, så den er fasiten.
      const grid = document.getElementById('ProductGridContainer');
      if (grid && 'MutationObserver' in window) {
        new MutationObserver(() => vis(urlSortering())).observe(grid, { childList: true });
      }

      // Tilbake-knappen i nettleseren: Dawn tegner siden på nytt, men vet
      // ikke om denne velgeren.
      window.addEventListener('popstate', () => {
        vis(urlSortering());
        oppdaterAntall();
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
